exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-tag+.el-tag[data-v-493f5286]{margin-left:10px}.button-new-tag[data-v-493f5286]{margin-left:10px;height:32px;line-height:30px;padding-top:0;padding-bottom:0}.input-new-tag[data-v-493f5286]{width:120px;margin-left:10px;vertical-align:bottom}.wrapper2[data-v-493f5286]{width:100%;overflow-x:scroll;overflow-y:hidden;position:absolute;z-index:999;top:100px}#div2[data-v-493f5286]{height:1px;overflow:scroll}\n", ""]);

// exports
